import { render } from "./dialog.vue?vue&type=template&id=3818f03a&ts=true"
import script from "./dialog.vue?vue&type=script&lang=ts"
export * from "./dialog.vue?vue&type=script&lang=ts"

import "./dialog.vue?vue&type=style&index=0&id=3818f03a&lang=scss"

import exportComponent from "/Users/star/Desktop/clz-frontend/taxi-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__